export default {
  future: '%s',
  past: 'hace %s',
  s: 'unos segundos',
  ss: '%d segundos',
  m: 'un minuto',
  mm: '%d minutos',
  h: 'una hora',
  hh: '%d horas',
  d: 'un día',
  dd: '%d días',
  M: 'un mes',
  MM: '%d meses',
  y: 'un año',
  yy: '%d años'
};
